import React, { ComponentType } from 'react';
import useIntersectionObserver from '../hooks/useIntersectionObserver';

const withLazyLoad = <P extends object>(WrappedComponent: ComponentType<P>, threshold = 0): React.FC<P> => {
    // eslint-disable-next-line react/display-name
    return (props: P) => {
        const [isInView, ref] = useIntersectionObserver(threshold);

        return <div ref={ref}>{isInView ? <WrappedComponent {...props} /> : <div>Loading...</div>}</div>;
    };
};

export default withLazyLoad;
